import { jsxs as h, jsx as m } from "react/jsx-runtime";
import { ImageFileInputThumbnail as p } from "./ImageFileInputMultiSelectThumbnail.mjs";
import { Icon as s } from "../../atoms/Icon/Icon.mjs";
import { cn as f } from "../../../utils/utils.mjs";
function j({
  children: n,
  multiple: c,
  previewUrls: t,
  onImageClose: i,
  className: l,
  multiImageContainerClassName: r
}) {
  return /* @__PURE__ */ h("div", { className: f("w-full flex flex-col items-center gap-3", l), children: [
    /* @__PURE__ */ m(s, { name: "image", width: 24, height: 24 }),
    n,
    c && t && t.length > 0 && /* @__PURE__ */ m("div", { className: f("flex gap-4 shrink-0 w-full justify-center", r), children: t.map((e, a) => /* @__PURE__ */ m(
      p,
      {
        id: a,
        previewUrl: e,
        onClose: (u) => i == null ? void 0 : i(u)
      },
      e
    )) })
  ] });
}
export {
  j as ImageFileInputDefaultState
};
